/* eslint-disable no-param-reassign */
import {
  ActionReducerMapBuilder,
  createAsyncThunk,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';

import {
  StationDetailsInitialProperties,
  StationDetailsInterface,
} from '../../interface/station-details.interface';
import stationDetailsApi from '../../utils/api/station-management';

export const fetchStationDetailsData = createAsyncThunk<StationDetailsInterface, string>(
  'station-details/fetchStationDetailsData',
  async (id, { dispatch }) => {
    try {
      const response = await stationDetailsApi.fetchStationDetails(id);
      return response.data;
    } catch (error: any) {
      dispatch({
        type: 'notification/setNotificationDetails',
        payload: {
          type: 'error',
          notificationDetails: {
            statusCode: error?.response?.data?.code || 200,
            message: error?.response?.data?.message || 'Something went wrong!',
          },
        },
      });
      throw error;
    }
  },
);

const initialState: StationDetailsInitialProperties = {
  stationDetails: null,
  isLoading: false,
};

export const stationDetailsSlice = createSlice({
  name: 'station-details',
  initialState,
  reducers: {},
  /**
   * Use the extra reducers function
   * @param builder
   */
  extraReducers: (builder: ActionReducerMapBuilder<StationDetailsInitialProperties>) => {
    builder
      .addCase(fetchStationDetailsData.pending, (state: StationDetailsInitialProperties) => {
        state.isLoading = true;
      })
      .addCase(
        fetchStationDetailsData.fulfilled,
        (
          state: StationDetailsInitialProperties,
          action: PayloadAction<StationDetailsInterface>,
        ) => {
          state.isLoading = false;
          state.stationDetails = action.payload; // ✅ correct type match
        },
      )
      .addCase(fetchStationDetailsData.rejected, (state: StationDetailsInitialProperties) => {
        state.isLoading = false;
      });
  },
});

export default stationDetailsSlice.reducer;
